import { VisibleEnabledFeatureAvailable } from 'modules/Cube/domain/cube.domain.types'

/**
 * Sending signature requests is offered from the sidebar's published card, which already decides
 * when it shows. So on its own this is always available, and only the rules composed onto it in
 * `getQuoteFeaturesAvailable` switch it off.
 */
export const getReadyToSignQuoteAvailable =
  (): VisibleEnabledFeatureAvailable => ({
    available: {
      visible: true,
      enabled: true
    },
    reasons: []
  })
